export const services = {
  plumbing: {
    id: "plumbing",
    title: "Plumbing Services",
    shortDescription:
      "Professional repairs, installations, and maintenance services.",
    fullDescription:
      "Our expert plumbing team delivers comprehensive solutions for all your residential and commercial needs. From emergency repairs to new installations, we ensure reliable, long-lasting results.",
    features: [
      "24/7 Emergency Services",
      "Licensed & Insured Plumbers",
      "Upfront Pricing",
      "Guaranteed Workmanship",
    ],
    icon: "🔧",
    image: "/assets/services/plumbing.jpg",
  },
  filtration: {
    id: "water-filtration",
    title: "Water Filtration",
    shortDescription: "Clean, pure water solutions for your home.",
    fullDescription:
      "Experience cleaner, healthier water throughout your home with our advanced filtration systems. We provide custom solutions to address your specific water quality concerns.",
    features: [
      "Whole-House Filtration Systems",
      "Reverse Osmosis Solutions",
      "Water Quality Testing",
      "Regular Maintenance Plans",
    ],
    icon: "💧",
    image: "/assets/services/water-filtration.jpg",
  },
  ac: {
    id: "ac",
    title: "Air Conditioning",
    shortDescription: "Expert cooling solutions for year-round comfort.",
    fullDescription:
      "Keep your home comfortable year-round with our professional AC services. From installation to maintenance, we ensure your system runs efficiently and reliably.",
    features: [
      "New System Installation",
      "Preventive Maintenance",
      "Energy Efficiency Upgrades",
      "24/7 Repair Services",
    ],
    icon: "❄️",
    image: "/assets/services/ac.jpg",
  },
  sewer: {
    id: "sewer",
    title: "Sewer Repair",
    shortDescription: "Fast, reliable sewer line repairs and maintenance.",
    fullDescription:
      "Resolve sewer line issues quickly with our advanced diagnostic and repair services. We use modern techniques to minimize disruption while ensuring lasting repairs.",
    features: [
      "Camera Inspection",
      "Trenchless Repairs",
      "Line Replacement",
      "Emergency Services",
    ],
    icon: "🚰",
    image: "/assets/services/sewer.jpg",
  },
  water: {
    id: "water-heaters",
    title: "Water Heaters",
    shortDescription:
      "Installation and repair of modern water heating systems.",
    fullDescription:
      "Ensure reliable hot water with our comprehensive water heater services. We specialize in both traditional and tankless systems, offering energy-efficient solutions.",
    features: [
      "Tankless Water Heaters",
      "Traditional Systems",
      "Energy Efficiency Updates",
      "Regular Maintenance",
    ],
    icon: "🌡️",
    image: "/assets/services/water-heaters.jpg",
  },
  heating: {
    id: "heating",
    title: "Heating Services",
    shortDescription: "Efficient heating solutions for your comfort.",
    fullDescription:
      "Stay warm with our professional heating services. We provide expert installation, maintenance, and repairs for all types of heating systems.",
    features: [
      "Furnace Installation",
      "Heat Pump Services",
      "System Maintenance",
      "Emergency Repairs",
    ],
    icon: "🔥",
    image: "/assets/services/heating.jpg",
  },
  drain: {
    id: "drain-cleaning",
    title: "Drain Cleaning",
    shortDescription: "Professional drain cleaning and clog removal services.",
    fullDescription:
      "Keep your drains flowing smoothly with our professional cleaning services. We use advanced tools and techniques to clear any blockage safely and effectively.",
    features: [
      "Hydro Jetting",
      "Camera Inspection",
      "Preventive Maintenance",
      "Emergency Service",
    ],
    icon: "🔧",
    image: "/assets/services/drain-cleaning.jpg",
  },
  air: {
    id: "air-purifier",
    title: "Air Purification",
    shortDescription: "Advanced air purification for healthier indoor air.",
    fullDescription:
      "Breathe cleaner, healthier air with our advanced purification systems. We offer solutions to remove allergens, pollutants, and improve overall air quality.",
    features: [
      "Whole-Home Systems",
      "HEPA Filtration",
      "UV Light Treatment",
      "Regular Maintenance",
    ],
    icon: "🌬️",
    image: "/assets/services/air-purifier.jpg",
  },
};
